import { isPageInFormProgress } from './helpers'
import { Page, StepPage } from 'directFlow/types'

export const defaultRouteValidationMap = ({
  isVan,
  formProgress,
}: {
  isVan: boolean
  formProgress: StepPage[]
}): Record<StepPage, boolean> => ({
  [Page.REGISTRATION]: true,
  [Page.MVL]: isPageInFormProgress(Page.REGISTRATION, formProgress),
  [Page.VEHICLE_FOUND]: isPageInFormProgress(Page.REGISTRATION, formProgress),
  [Page.VEHICLE]: isPageInFormProgress(Page.VEHICLE_FOUND, formProgress),
  [Page.DRIVERS]: isPageInFormProgress(Page.VEHICLE, formProgress),
  [Page.LICENCE]: isPageInFormProgress(Page.DRIVERS, formProgress),
  [Page.HISTORY]: isPageInFormProgress(Page.LICENCE, formProgress),
  [Page.CLAIM_FREE_DISCOUNT]: isPageInFormProgress(Page.HISTORY, formProgress),
  [Page.PREVIOUS_CANCELLATION]: !isVan && isPageInFormProgress(Page.HISTORY, formProgress),
  [Page.PREVIOUS_CANCELLATION_YEAR]:
    !isVan && isPageInFormProgress(Page.PREVIOUS_CANCELLATION, formProgress),
  [Page.USAGE]: !isVan
    ? isPageInFormProgress(Page.PREVIOUS_CANCELLATION_YEAR, formProgress)
    : isPageInFormProgress(Page.HISTORY, formProgress),
  [Page.POLICY_START_DATE]: isPageInFormProgress(Page.USAGE, formProgress),
})
